import { AuthMode } from '@naturalcycles/shared'

export const isSignupMode = (mode: AuthMode): boolean =>
  [AuthMode.signup, AuthMode.activateSignup, AuthMode.quizSignup].includes(mode)
